module.exports = {"closeDate":null,"company":null,"contactName":null,"phone":null,"email":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/my_deals/actions/payoff/resources/model.json
// module id = ksa1
// module chunks = 1